export default __webpack_public_path__ + "static/media/MINUSTAH_capacity_building_of_state_forces.bf44ff7f.png";